import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import formDefault from "../../docs/formDefault.json";

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    init_claim_inputs() {
        const claimInputsContact =
            "#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST";
        const claimInputsFields =
            "#claim-fields input, #claim-fields textarea, #claim-fields select";
        const claimInputsFieldsPayment =
            "#payment_method, #payment_token, #payment_email, #payment_phone";
        const claimInputsTransactions =
            "[id^='transactions_'] input, [id^='transactions_'] textarea, [id^='transactions_'] select";

        this.claim.inputs.contact = Array.from(
            document.querySelectorAll(claimInputsContact)
        );
        this.claim.inputs.fields = Array.from(
            document.querySelectorAll(
                claimInputsFields + ", " + claimInputsFieldsPayment
            )
        ).filter((field) => !field.closest("td.transaction"));
        this.claim.inputs.transactions = Array.from(
            document.querySelectorAll(claimInputsTransactions)
        );
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }
}
